import React, { useState } from 'react';
import { Menu, MenuItem, Button, Box, Typography } from '@mui/material';
import PropTypes from 'prop-types';
import Iconify from '../../../reusable-components/iconify';
import { useTabs } from '../../../context/TabContext';

OrderTicketsDropdown.propTypes = {
  params: PropTypes.object,
};
export default function OrderTicketsDropdown({params, e}) {
    const { addNewTabAndNavigate } = useTabs();

    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);

    const handleClick = (event) => {
      event.preventDefault();
      event.stopPropagation();
      setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
      setAnchorEl(null);
    };
    const handleMenuItemClick = (ticketId, e) => {
      e.stopPropagation();
      if (ticketId > 0) {
        addNewTabAndNavigate(`/dashboard/tickets/${ticketId}`);
      }
      handleClose();
    };

    if (!params.value || params.value.length === 0) return null;

    return params.value.length > 1 ? <>
      <Button
        variant="outlined"
        size="small"
        onClick={handleClick}
      >
        Tickets ({params.value.length})
        <Iconify icon="mdi:chevron-down" />
      </Button>
      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
      >
        {params.value.map((ticketId) => (
          <MenuItem
            key={ticketId}
            onClick={(e) => handleMenuItemClick(ticketId, e)}
          >
            {ticketId}
          </MenuItem>
        ))}
      </Menu>
    </> : 
    <Box
      sx={{cursor:'pointer'}}
      onClick={(e) => params.value.length && handleMenuItemClick(params.value[0], e)}
    >
      <Typography
        variant="subtitle2"
        component="span"
        sx={{textDecoration: 'underline'}}
      >
        {params.value.length > 0 && params.value[0]}
      </Typography>
    </Box>
  }